import { PokemonSkillCard } from "@/components/pokemon/pokemon-skill-card";
import { SimpleButton } from "@/components/ui/buttons/simple-button";
import { LoadingOverlay } from "@/components/ui/overlays/loading-overlay";
import { CheckIcon, PencilIcon } from "@/icons";

import type { SkillData } from "types/battle-engine/battle";

type SkillSectionProps = {
  isEditingSkills: boolean;
  handleConfirm: () => void;
  handleCancelEdit: () => void;
  isSubmittingSkillChanges: boolean;
  skills: SkillData[];
  knownSkills: SkillData[];
  selectedSkills: string[];
  handleSkillToggle: (skillId: string) => void;
  handleEditClick: () => void;
}

export const SkillSection = ({
  isEditingSkills,
  handleSkillToggle,
  handleEditClick,
  handleConfirm,
  handleCancelEdit,
  isSubmittingSkillChanges,
  skills,
  knownSkills,
  selectedSkills,
}: SkillSectionProps) => {
  return (
      <div className="flex flex-col items-start gap-2 mt-2 mb-auto w-full">
        <div className="flex justify-between items-center bg-pk-gray-2 opacity-70 p-2 rounded-sm w-full">
          <h2 className="font-bold text-pk-gray-4 text-2xl">Skills</h2>
          {isEditingSkills ? (
            <div className="flex items-center gap-4">
              <SimpleButton
                variant="garnet"
                className="py-1"
                onClick={handleConfirm}
                loading={isSubmittingSkillChanges}
              >
                <div className="flex items-center gap-2">
                  <CheckIcon width={24} height={24} className="invert" />
                  Confirm
                </div>
              </SimpleButton>
              
              <SimpleButton
                variant="garnet"
                className="py-1"
                onClick={handleCancelEdit}
              >
                Cancel
              </SimpleButton>
            </div>
          ) : (
            <SimpleButton
              variant="garnet"
              className="py-1"
              onClick={handleEditClick}
            >
              <div className="flex items-center gap-4">
                <PencilIcon width={16} height={16} className="" />
                Edit
              </div>
            </SimpleButton>
          )}
        </div>
        {isEditingSkills ? (
          <div className="relative w-full">
            <LoadingOverlay
              isVisible={isSubmittingSkillChanges}
              message="Updating Skills..."
              spinnerColor="border-pk-green-3"
            />
            <div className="gap-2 grid grid-cols-1 xs:grid-cols-2 w-full">
              {knownSkills.map(
                (skill) =>
                  skill && (
                    <PokemonSkillCard
                      key={skill.id}
                      skill={skill}
                      isSelected={selectedSkills.includes(
                        skill.id.replace(/_/g, "-"),
                      )}
                      onClick={() => handleSkillToggle(skill.id)}
                      isSelectable={true}
                    />
                  ),
              )}
            </div>
          </div>
        ) : (
          <div className="gap-2 grid grid-cols-1 w-full">
            {skills.map(
              (skill) =>
                skill && (
                  <PokemonSkillCard key={skill.id} skill={skill} />
                ),
            )}
          </div>
        )}
      </div>
  );
}